webpackJsonp([263910457428570],{

/***/ 362:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby + Netlify CMS Starter"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/2017-01-05-using-git-for-docs/"},"frontmatter":{"title":"Using Git for Docs"}}}]}},"pathContext":{"tag":"docs"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-docs-4e3b7ef994a830393919.js